/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shift_Word_Forward_Aria_LabelInputs */

const en_shift_word_forward_aria_label = /** @type {(inputs: Shift_Word_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shift Word Down`)
};

const fr_shift_word_forward_aria_label = /** @type {(inputs: Shift_Word_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decaler le Mot en Bas`)
};

const de_shift_word_forward_aria_label = /** @type {(inputs: Shift_Word_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wort nach unten verschieben`)
};

const it_shift_word_forward_aria_label = /** @type {(inputs: Shift_Word_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta parola verso il basso`)
};

const ru_shift_word_forward_aria_label = /** @type {(inputs: Shift_Word_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сдвинуть слово вниз`)
};

const es_shift_word_forward_aria_label = /** @type {(inputs: Shift_Word_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazar palabra hacia abajo`)
};

const zh_cn2_shift_word_forward_aria_label = /** @type {(inputs: Shift_Word_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向下移动单词`)
};

const ja_shift_word_forward_aria_label = /** @type {(inputs: Shift_Word_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語を下へシフト`)
};

const hi_shift_word_forward_aria_label = /** @type {(inputs: Shift_Word_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शब्द को नीचे ले जाएं`)
};

const pt_pt2_shift_word_forward_aria_label = /** @type {(inputs: Shift_Word_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desloque a palavra para baixo`)
};

/**
* | output |
* | --- |
* | "Shift Word Down" |
*
* @param {Shift_Word_Forward_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shift_word_forward_aria_label = /** @type {((inputs?: Shift_Word_Forward_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shift_Word_Forward_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shift_word_forward_aria_label(inputs)
	if (locale === "de") return de_shift_word_forward_aria_label(inputs)
	if (locale === "it") return it_shift_word_forward_aria_label(inputs)
	if (locale === "ru") return ru_shift_word_forward_aria_label(inputs)
	if (locale === "es") return es_shift_word_forward_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_shift_word_forward_aria_label(inputs)
	if (locale === "ja") return ja_shift_word_forward_aria_label(inputs)
	if (locale === "hi") return hi_shift_word_forward_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_shift_word_forward_aria_label(inputs)
	return en_shift_word_forward_aria_label(inputs)
});